import { render, staticRenderFns } from "./TaskTypeFiltering.vue?vue&type=template&id=dc73486a&"
import script from "./TaskTypeFiltering.vue?vue&type=script&lang=js&"
export * from "./TaskTypeFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports